export const Messages = {
  renameError: (message: string) => ({
    title: `Renaming failed`,
    message,
  }),
  cantObtainAssetTypes: (title: string) => ({
    title,
  }),
};
